module.exports = __webpack_public_path__ + "img/icon_trophy.4a9079e.svg";